"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEncoder = (instance) => 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
instance !== null && typeof instance['encode'] === 'function';
exports.isDecoder = (instance) => 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
instance !== null && typeof instance['decode'] === 'function';
exports.isTypedArray = (instance) => instance instanceof Uint8Array ||
    instance instanceof Uint16Array ||
    instance instanceof Uint32Array;
exports.isNotNullObject = (instance) => typeof instance === 'object' && instance !== null;
exports.keyInObject = (v, key) => key in v;
// export const isIndexable = (instance: unknown, value: string): value is keyof typeof instance => {
//   return typeof instance === 'object' && instance !== null && value in instance
// }
